"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoDocument = void 0;
class MongoDocument {
}
exports.MongoDocument = MongoDocument;
//# sourceMappingURL=mongo-document.model.js.map